import {
  V2Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  VisuallyHidden,
} from "web-design-system";
import { Route } from "@/routes/(auth)/_headed/clients/$id/planning";
import { useNavigate } from "@tanstack/react-router";
import { omit } from "lodash";
import { GoalUIState } from "../../providers/goal-context-provider";
import { GoalBuilder } from "./goal-form";

export function GoalsDialog() {
  const { client_id, goal_id, state = "create", goal_type } = Route.useSearch();

  const navigate = useNavigate();

  if (!client_id) return null;

  return (
    <V2Dialog
      open
      onOpenChange={(o) =>
        !o &&
        navigate({
          to: ".",
          replace: true,
          search: (prev) =>
            omit(prev, ["client_id", "goal_id", "state", "modal", "goal_type"]),
        })
      }
    >
      <DialogContent className="h-150 p-0 w-120">
        <VisuallyHidden>
          <DialogHeader>
            <DialogTitle className="text-muted-foreground font-medium">
              Create Goal
            </DialogTitle>
          </DialogHeader>
        </VisuallyHidden>
        <GoalBuilder
          goalId={goal_id}
          clientId={client_id}
          state={state as GoalUIState}
          goalType={goal_type}
        />
      </DialogContent>
    </V2Dialog>
  );
}
